import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'

// This listener is decoupled from the wrapper for performance- so the onScroll listener only fires for desktop
class StickyCSHListener extends React.Component {
  static propTypes = {
    stickyCSHAnchorId: PropTypes.string.isRequired,
    stickyCSHWrapperId: PropTypes.string.isRequired,
    hiddenClassName: PropTypes.string.isRequired,
    threshold: PropTypes.number
  }

  static defaultProps = {
    threshold: 90 // amount of pixels to have scrolled down before triggering hiding effect
  }

  constructor(props) {
    super(props)
    this.prevPos = null
  }

  componentDidMount() {
    const { stickyCSHAnchorId, stickyCSHWrapperId } = this.props
    const { hiddenClassName } = this.props
    document.body.classList.add(`for-${hiddenClassName}`)
    document.addEventListener('scroll', this.onScroll)
    this.anchorRef = document.getElementById(stickyCSHAnchorId)
    this.stickyRef = document.getElementById(stickyCSHWrapperId)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.onScroll)
  }

  onScroll = () => {
    const { hiddenClassName, threshold } = this.props
    const anchor = this.anchorRef
    const sticky = this.stickyRef

    if (!get(sticky, 'classList') || !get(anchor, 'getBoundingClientRect')) {
      return
    }
    const anchorPos = anchor.getBoundingClientRect().top
    const currentPos =
      get(document, 'documentElement.scrollTop') ||
      get(document, 'body.scrollTop')

    if (anchorPos < -threshold) {
      if (this.prevPos && currentPos < this.prevPos) {
        sticky.classList.remove(`${hiddenClassName}`)
        document.body.classList.remove(`${hiddenClassName}`)
      } else if (!sticky.classList.contains(`${hiddenClassName}`)) {
        sticky.classList.add(`${hiddenClassName}`)
        document.body.classList.add(`${hiddenClassName}`)
      }
    } else if (sticky.classList.contains(`${hiddenClassName}`)) {
      sticky.classList.remove(`${hiddenClassName}`)
      document.body.classList.remove(`${hiddenClassName}`)
    }
    this.prevPos = currentPos
  }

  render() {
    return null
  }
}

export { StickyCSHListener }
